import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify.js'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import i18n from './lang/lang.js'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'



Vue.use(Vuelidate)
Vue.use(VueMoment, {
  moment
});

Vue.config.productionTip = false

window.vm = new Vue({
  router,
  store: store,
  i18n,
  render: h => h(App)
}).$mount('#app')
